// Notification preferences: Select All and master sync via delegated events
// Works with dynamically injected partials because it binds once at document level.
(function() {
  // Basic logger (can be disabled by setting window.NOTIF_PREF_DEBUG=false)
  var DEBUG = (typeof window.NOTIF_PREF_DEBUG === 'undefined') ? true : !!window.NOTIF_PREF_DEBUG;
  function log(){ if (DEBUG && window.console && console.debug) { try { console.debug.apply(console, ['[notif-pref]'].concat([].slice.call(arguments))); } catch(_) {} } }

  function containerFor(target) {
    if (target && target.closest) {
      var c = target.closest('table.notification-preferences');
      if (c) return c;
    }
    return document;
  }

  function handleMasterToggleFrom(masterEl, targetClass) {
    if (!masterEl) return;
    var cont = containerFor(masterEl);
    var checked = !!masterEl.checked;
    cont.querySelectorAll('input.' + targetClass + ':not(:disabled)').forEach(function(cb){
      cb.checked = checked;
    });
  }

  function syncMasterInContainer(cont, masterSelector, targetClass) {
    var master = cont.querySelector(masterSelector);
    if (!master) return;
    var boxes = Array.prototype.slice.call(cont.querySelectorAll('input.' + targetClass + ':not(:disabled)'));
    if (boxes.length === 0) { master.checked = false; return; }
    master.checked = boxes.every(function(cb){ return cb.checked; });
  }

  function onEvent(e) {
    var t = e.target;
  log('event', e.type, t && t.id, t && t.className);
    // Handle clicks on label/span by resolving to input if possible
    var masterEmail = t.closest ? t.closest('#select_all_email') : null;
    var masterSms = t.closest ? t.closest('#select_all_sms') : null;

    if (masterEmail) {
      handleMasterToggleFrom(masterEmail, 'pref-email');
      syncMasterInContainer(containerFor(masterEmail), '#select_all_email', 'pref-email');
      return;
    }
    if (masterSms) {
      handleMasterToggleFrom(masterSms, 'pref-sms');
      syncMasterInContainer(containerFor(masterSms), '#select_all_sms', 'pref-sms');
      return;
    }

    if (t && t.classList) {
      if (t.classList.contains('pref-email')) {
        syncMasterInContainer(containerFor(t), '#select_all_email', 'pref-email');
        return;
      }
      if (t.classList.contains('pref-sms')) {
        syncMasterInContainer(containerFor(t), '#select_all_sms', 'pref-sms');
        return;
      }
    }
  }

  // Use capture to avoid being blocked by stopPropagation from other scripts
  document.addEventListener('change', onEvent, true);
  document.addEventListener('click', onEvent, true);

  // Directly bind to master checkboxes as well, in case some libs interfere with delegated events
  function bindMasters(root){
    var scope = root || document;
    scope.querySelectorAll('#select_all_email, #select_all_sms').forEach(function(el){
      if (el.dataset && el.dataset.npBound) return;
      if (el.dataset) el.dataset.npBound = '1';
      var isEmail = el.id === 'select_all_email';
      var cls = isEmail ? 'pref-email' : 'pref-sms';
      var masterSel = isEmail ? '#select_all_email' : '#select_all_sms';
      var handler = function(){
        handleMasterToggleFrom(el, cls);
        syncMasterInContainer(containerFor(el), masterSel, cls);
      };
      el.addEventListener('change', handler);
      el.addEventListener('click', handler);
      log('bound master', el.id);
    });
  }

  // Initialize master states on load in case boxes are pre-checked
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      log('init DOMContentLoaded');
      bindMasters(document);
      document.querySelectorAll('table.notification-preferences').forEach(function(cont){
        syncMasterInContainer(cont, '#select_all_email', 'pref-email');
        syncMasterInContainer(cont, '#select_all_sms', 'pref-sms');
      });
    });
  } else {
    log('init immediate');
    bindMasters(document);
    document.querySelectorAll('table.notification-preferences').forEach(function(cont){
      syncMasterInContainer(cont, '#select_all_email', 'pref-email');
      syncMasterInContainer(cont, '#select_all_sms', 'pref-sms');
    });
  }

  // Observe dynamic injections of the partial and bind/select masters in new subtrees
  try {
    var mo = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(node){
          if (!(node instanceof Element)) return;
          if (node.matches && node.matches('table.notification-preferences')) {
            log('observer: new table');
            bindMasters(node);
            syncMasterInContainer(node, '#select_all_email', 'pref-email');
            syncMasterInContainer(node, '#select_all_sms', 'pref-sms');
          } else {
            // If a subtree contains our elements
            var tables = node.querySelectorAll ? node.querySelectorAll('table.notification-preferences') : [];
            if (tables && tables.length) {
              tables.forEach(function(cont){
                log('observer: table in subtree');
                bindMasters(cont);
                syncMasterInContainer(cont, '#select_all_email', 'pref-email');
                syncMasterInContainer(cont, '#select_all_sms', 'pref-sms');
              });
            } else {
              // Bind masters that may have been directly added
              bindMasters(node);
            }
          }
        });
      });
    });
    mo.observe(document.documentElement || document.body, { childList: true, subtree: true });
    log('observer started');
  } catch (e) {
    log('observer error', e);
  }
})();
